import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateMessageStatus } from '../../../../../../../../store/crm/actions';
import { selectConversationHistory } from '../../../../../../../../store/crm/selectors';
import { parseMessage } from '../../../../../../../../utils/crm';
const usePendingMessageWatcher = () => {
  const conversationHistory = useSelector((state) => selectConversationHistory(state));
  const messages = conversationHistory.map(parseMessage);
  const dispatch = useDispatch();
  const timers = useRef({});

  useEffect(() => {
    messages.forEach((msg) => {
      if (msg.sendStatus === 'pending' && !timers.current[msg.id]) {
        // Set timeout for 60s
        timers.current[msg.id] = setTimeout(() => {
          dispatch(updateMessageStatus({ id: msg.id, status: 'failed' }));
          delete timers.current[msg.id];
        }, 60000);
      }

      // If status was updated externally, clear timer
      if (msg.sendStatus !== 'pending' && timers.current[msg.id]) {
        clearTimeout(timers.current[msg.id]);
        delete timers.current[msg.id];
      }
    });

    return () => {
      // Cleanup on unmount
      Object.values(timers.current).forEach(clearTimeout);
    };
  }, [conversationHistory, dispatch]);
};
export default usePendingMessageWatcher;
